/* eslint-disable @typescript-eslint/no-explicit-any */
import { ENDPOINTS } from '@/util'
import { useSuspenseQuery } from '@tanstack/react-query'
import { TableResponse } from './types-v4'
import { useGetFilterSelections } from '@/catalog-apps/hooks/useGetFilterSelections'
import { useAppContext } from '@/catalog-apps/hooks/useAppContext'
import { useGetPageFilters } from '../../AppPage2/Filter/useGetPageFilters'
import { useIsPageBuilder } from '@/catalog-apps/hooks/useIsPageBuilder'
import { TComponentType } from '../../AppPage2/types'

const USE_MOCK_DATA = false
const MOCK_DATA_DELAY = 0

interface GetTableParams {
  appKey?: string
  contentId?: string
  projectId?: number
  filterSelections: Record<string, any>[]
  isPageBuilder?: boolean
}
const getTable = async ({ appKey, contentId, projectId, filterSelections, isPageBuilder }: GetTableParams) => {
  if (!appKey || !contentId || !projectId) {
    throw new Error('Missing required parameters')
  }
  if (isPageBuilder) {
    return Promise.resolve(
      (await import('@/catalog-apps/mock-data/table/table-response-4-rows.json')).json as TableResponse
    )
  }
  if (USE_MOCK_DATA) {
    return new Promise<TableResponse>((resolve) => {
      setTimeout(async () => {
        // const data = (await import('@/catalog-apps/mock-data/table/table-grouped/table-grouping-riaan.json'))
        const data = (await import('@/catalog-apps/mock-data/table/table-selection-export.json')).json as TableResponse
        resolve(data)
      }, MOCK_DATA_DELAY)
    })
  }
  const token = JSON.parse(sessionStorage.getItem('token') || '')
  if (!token) {
    throw new Error('No token found')
  }
  const url = `${ENDPOINTS.CC_DOTNET}/content`
  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify({
      app_id: appKey,
      content_id: contentId,
      project_id: projectId,
      filters: filterSelections,
    }),
  })
  const data = await response.json()
  if (response.ok) {
    // return data.uiSchema as PageData
    return data as TableResponse
  }
  throw new Error('Failed to fetch app page')
}

export function useGetTable(contentId: string, tileFilterSelections: Record<string, any>[]) {
  const isPageBuilder = useIsPageBuilder()
  const {
    data: { defaultSelections },
  } = useGetPageFilters()
  const { filterSelections } = useGetFilterSelections()
  const { appKey, projectId } = useAppContext()
  const filterSelectionsArray =
    filterSelections.length > 0
      ? [...filterSelections, ...tileFilterSelections]
      : [...defaultSelections, ...tileFilterSelections]
  const componentType: TComponentType = 'table'
  return useSuspenseQuery({
    queryKey: [contentId, componentType, appKey, projectId, filterSelectionsArray, isPageBuilder],
    queryFn: () => getTable({ appKey, contentId, projectId, filterSelections: filterSelectionsArray, isPageBuilder }),
  })
}
